import React, { useState, useEffect, useRef } from 'react'
import { Icon, Whisper, Tooltip, Button, Dropdown, IconButton } from 'rsuite'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { isMobile } from 'react-device-detect'
import { logout, clearSession, clearSessionStorage } from '../../redux/actions/auth'
import { Logo } from '../SvgIcons'
import PDPAInfo from '../../widgets/cookie/PDPAInfo'
import './styles.less'
import ProjectVersion from '../../widgets/cookie/ProjectVersion'
import { DEFAULT_NAV_ITEMS, LOGIN_NAV_ITEMS, LOGOUT_NAV_ITEMS } from '../../constants/constants'
import { getTopLevelNavSchema } from '../../redux/actions/topLevelNav'

function ButtonWithTooltip({ children, tip, className, ...props }) {
  const btn = (
    <Button {...props} size="lg" className={classNames('icon-btn-circle', className)}>
      {children}
    </Button>
  )

  if (isMobile) {
    return btn
  }

  return (
    <Whisper speaker={<Tooltip>{tip}</Tooltip>} placement="autoHorizontalEnd" trigger="hover">
      {btn}
    </Whisper>
  )
}

export default function TopLevelNavNew({ setIsLogin = () => {}, ...props }) {
  const { children } = props

  const access_token = localStorage.getItem('access_token')
  const termsUrl = localStorage.getItem('termsUrl')

  const containerRef = useRef(null)

  const [navItems, setNavItems] = useState([])
  const [navItemsMore, setNavItemsMore] = useState([])
  // const [isLoading, setIsLoading] = useState()
  // const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)
  const [windowHeight, setWindowHeight] = useState(0)
  const [isApiCalled, setIsApiCalled] = useState(false)
  const [isHeight, setIsHeight] = useState(false)

  const TOKEN_TYPE = localStorage.getItem('token_type')

  useEffect(() => {
    const offsetHeight = containerRef.current.offsetHeight
    const offsetWidth = containerRef.current.offsetWidth

    if (access_token) {
      handleGetTopLevelNavSchema(offsetHeight, offsetWidth)
    } else {
      genTopLevelNav([...DEFAULT_NAV_ITEMS, LOGIN_NAV_ITEMS], offsetHeight, offsetWidth)
    }
  }, [])

  const handleResize = () => {
    setWindowHeight(window.innerHeight)
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      const offsetHeight = containerRef.current.offsetHeight
      const offsetWidth = containerRef.current.offsetWidth

      if (access_token) {
        if (isApiCalled) {
          genTopLevelNav([...navItems, ...navItemsMore], offsetHeight, offsetWidth)
        } else {
          handleGetTopLevelNavSchema(offsetHeight, offsetWidth)
        }
      } else {
        genTopLevelNav([...DEFAULT_NAV_ITEMS, LOGIN_NAV_ITEMS], offsetHeight, offsetWidth)
      }
    }
  }, [containerRef, windowHeight, windowWidth])

  const handleGetTopLevelNavSchema = async (offsetHeight, offsetWidth) => {
    // setIsLoading(true)
    try {
      const response = await getTopLevelNavSchema()

      let menuItems = [...(response?.topLevelNav || DEFAULT_NAV_ITEMS), LOGOUT_NAV_ITEMS]

      setIsApiCalled(true)
      genTopLevelNav(menuItems, offsetHeight, offsetWidth)
    } catch (e) {
      console.log(e)
    }
    // setIsLoading(false)
  }

  const genTopLevelNav = (menuItems, offsetHeight, offsetWidth) => {
    try {
      // console.log('offsetHeight : ', offsetHeight, 'offsetWidth : ', offsetWidth)
      let arrNewOne = [],
        arrNewTow = [],
        viewSize = 0

      var isUseHeight = offsetWidth <= 64
      viewSize = getEnableSize(isUseHeight, offsetHeight, offsetWidth)

      menuItems?.map((item, index) => {
        if (index + 1 <= viewSize) {
          arrNewOne.push(item)
        } else {
          arrNewTow.push(item)
        }
      })
      setIsHeight(isUseHeight)
      setNavItems(arrNewOne)
      setNavItemsMore(arrNewTow)
    } catch (e) {}
  }

  const handleLogout = async () => {
    try {
      const result = await logout()
      clearSession(result)
    } catch (e) {
      clearSession()
    }
  }

  const getEnableSize = (isUseHeight, height, width) => {
    let navItemSize = 0
    let difSize = 55
    let enableSize = 160
    let size = height

    if (!isUseHeight) {
      enableSize = 100
      size = width
    }

    while (size >= enableSize) {
      navItemSize++

      enableSize += difSize
    }

    return navItemSize
  }

  return (
    <>
      <div>
        <div className="top-level-nav" ref={containerRef}>
          <Link to="/" onClick={() => clearSessionStorage()}>
            <img width={35} height={28} className="logo-sm" src={Logo}></img>
          </Link>

          <div className="top-level-nav-header">
            {navItems?.map((item) => {
              if (item.key == 'sign-out') {
                return (
                  <>
                    {TOKEN_TYPE != 'THR' && (
                      <ButtonWithTooltip
                        tip={item.tip}
                        key={item.key}
                        onClick={() => handleLogout()}
                      >
                        <Icon icon={item.icon} size="lg" />
                      </ButtonWithTooltip>
                    )}
                  </>
                )
              } else if (item.key == 'sign-in') {
                return (
                  <ButtonWithTooltip
                    tip={item.tip}
                    key={item.key}
                    onClick={() => {
                      console.log('click login')

                      setIsLogin(true)
                    }}
                  >
                    <Icon icon={item.icon} size="lg" />
                  </ButtonWithTooltip>
                )
              }
              return (
                <ButtonWithTooltip
                  tip={item.tip}
                  key={item.key}
                  to={{ pathname: item.to }}
                  componentClass={Link}
                  onClick={() => {
                    clearSessionStorage()
                  }}
                >
                  <Icon icon={item.icon} size="lg" />
                </ButtonWithTooltip>
              )
            })}

            {navItemsMore?.length > 0 && (
              <Dropdown
                renderTitle={() => {
                  return (
                    <Whisper
                      speaker={<Tooltip>{'เมนูเพิ่มเติม...'}</Tooltip>}
                      placement="autoHorizontalEnd"
                      trigger="hover"
                    >
                      <IconButton
                        size="lg"
                        icon={<Icon icon="ellipsis-h" />}
                        className={classNames('icon-btn-circle')}
                      />
                    </Whisper>
                  )
                }}
                placement={isHeight ? 'topStart' : 'bottomEnd'}
              >
                {navItemsMore.map((item, index) => {
                  if (item.key == 'sign-out') {
                    return (
                      <>
                        {TOKEN_TYPE != 'THR' && (
                          <Dropdown.Item
                            key={item.key}
                            className="dropdown-item"
                            icon={<Icon icon={item.icon} style={{ color: '#979090' }} />}
                            onClick={() => handleLogout()}
                          >{`  ${item.tip}`}</Dropdown.Item>
                        )}
                      </>
                    )
                  }

                  return (
                    <Link to={item.to} key={index}>
                      <Dropdown.Item
                        className="dropdown-item"
                        key={item.key}
                        icon={<Icon icon={item.icon} style={{ color: '#979090' }} />}
                        // icon={<Icon icon={item.icon} />}
                      >{`  ${item.tip}`}</Dropdown.Item>
                    </Link>
                  )
                })}
              </Dropdown>
            )}

            {/* {access_token ? (
              <ButtonWithTooltip tip={'ออกจากระบบ'} key={'sign-out'} onClick={() => handleLogout()}>
                <Icon icon={'sign-out'} size="lg" />
              </ButtonWithTooltip>
            ) : (
              <ButtonWithTooltip
                tip={'เข้าใช้งานระบบ'}
                key={'sign-in'}
                to={{ pathname: pathname.dashboardRoot }}
                componentClass={Link}
                isLogin={access_token}
              >
                <Icon icon={'sign-in'} size="lg" />
              </ButtonWithTooltip>
            )} */}
          </div>

          {children}
        </div>

        {termsUrl && <PDPAInfo termsUrl={termsUrl} />}

        <ProjectVersion />
      </div>
    </>
  )
}
